import React from 'react'
import {
  HookRouter as HookRouterTypes,
  useRedirect,
  useRoutes,
} from 'hookrouter'

import { AcceptInviteForm } from 'pages/AcceptInviteForm'
import { Login } from 'pages/Login'
import { NotFound } from 'pages/NotFound'
import { APP_ROUTES } from '../AppRouter'
import { PasswordResetConfirmationForm } from '../PasswordResetConfirmationForm'
import { PasswordResetEmailForm } from '../PasswordResetEmailForm'
import { UserRegistration } from 'pages/UserRegistration'
import { SignDocumentView } from 'pages/SignDocumentView'

export const LOGIN_ROUTES = {
  acceptInvite: '/accept_invite/:token',
  login: '/login',
  passwordReset: '/password_reset/:token',
  passwordResetTrigger: '/password_reset',
  signup: '/signup',
}

export const LoginRouter = () => {
  const routes = {
    [LOGIN_ROUTES.login]: () => <Login />,
    [LOGIN_ROUTES.signup]: () => <UserRegistration />,
    [LOGIN_ROUTES.acceptInvite]: ({ token }) => (
      <AcceptInviteForm token={token} />
    ),
    [LOGIN_ROUTES.passwordResetTrigger]: () => <PasswordResetEmailForm />,
    [LOGIN_ROUTES.passwordReset]: ({ token }) => (
      <PasswordResetConfirmationForm token={token} />
    ),
    [APP_ROUTES.signDocument]: ({ status }) => (
      <SignDocumentView status={String(status)} />
    ),
  } as HookRouterTypes.RouteObject

  useRedirect(APP_ROUTES.root, LOGIN_ROUTES.login)

  return useRoutes(routes) || <NotFound />
}
